import { compareAsc, fromUnixTime } from 'date-fns';

export default function sortDates(dateSet: number[] | undefined): Date[] {
  if (!dateSet) return [];

  return dateSet.map((time) => fromUnixTime(time)).sort(compareAsc);
}
